module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-4000-Classes-Inactive-d97d8468d4fe6848093f5c951b125507.png";